module.exports = __webpack_public_path__ + "img/cmr.7412bbcf.png";